<template lang="pug">
  #contract-neo-confirm-data
    h4.mx-2.mt-1.mb-4.text-center.border.message-border-style.border-primary.rounded.p-3 送信前に入力内容をご確認ください。
    b-container(fluid="fluid")
    b-row
      b-col
        b-row
          b-col
            b-row.align-items-center(:class="plan_service_title_class")
              h5.font-weight-bold.mr-2.mb-0 {{plans[regist_data.plan.type || ''].title}}
              .mr-3(v-if="plans[regist_data.plan.type || ''].services.includes('neo')")
                img.logo_desknets(src="@/assets/images/logo_desknetsneo_clear_background.png")
              .mr-3(v-if="plans[regist_data.plan.type || ''].services.includes('appsuite')")
                img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
              .mr-3(v-if="plans[regist_data.plan.type || ''].services.includes('chatluck')")
                img.logo_chatluck(src="@/assets/images/logo_chatluck.png")
              h5.font-weight-bold.mb-0 （1ユーザー￥{{plans[regist_data.plan.type || ''].price.toLocaleString()}}/月）
              b-button.anchor-button.ml-2(size="sm", :to="{name: 'ApplyPlan'}") 修正
            b-form-text(:class="plan_service_data_class") {{regist_data.plan.user}} ユーザー
            b-form-text(style="height: 30px;")
        template(v-if="regist_data.plan.type === 'light' && regist_data.app_suite_user")
          h5(:class="neo_service_title_class") 業務アプリ作成ツール AppSuite（1ユーザー￥550/月）
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#app-suite'}") 修正
          b-form-text(:class="neo_service_data_class") {{regist_data.app_suite_user}} ユーザー
          b-form-text(style="height: 30px;")
        template(v-if="regist_data.web_conferencing")
          h5(:class="neo_service_title_class") desknet's NEO ウェブ会議（1会議室￥11,000/月）
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#web-conferencing'}") 修正
          b-form-text(:class="neo_service_data_class") {{regist_data.web_conferencing}} 会議室
          b-form-text(style="height: 30px;")
        template(v-if="regist_data.option && Object.keys(regist_data.option).length > 0")
          h5(:class="neo_service_title_class") オプションサービス
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#option-service'}") 修正
          b-form-text(v-if="regist_data.option.room_mgr" :class="neo_option_data_class") RoomMgr（￥22,000/月）： 利用する
          b-form-text(v-if="regist_data.option.expense_settlement" :class="neo_option_data_class") 交通費経費精算（1ユーザー￥110/月）： 利用する
          b-form-text(v-if="regist_data.option.clouza" :class="neo_option_data_class") タイムカード＋CLOUZA（10ユーザー￥2,200/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left {{regist_data.option.clouza.user}} ユーザー
                b-form-text.text-left(v-if="regist_data.option.clouza.clouza_company") お試し環境からの引き継ぎコード : {{regist_data.option.clouza.clouza_company}}
                b-form-text.text-left(v-if="regist_data.option.clouza.paid_leave_option") 有休管理＋申請承認オプション（10ユーザー￥1,650/月）
          b-form-text(v-if="regist_data.option.disk" :class="neo_option_data_class") ディスク増設（20GBあたり￥2,200/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left 20GB × {{regist_data.option.disk.disk_size}} = {{regist_data.option.disk.disk_size*20}} GB増設
          b-form-text(v-if="regist_data.option.sync" :class="neo_option_data_class") Sync for smartphones（1ユーザー￥220/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left {{regist_data.option.sync.user}} ユーザー
          //- desknet'sドライブ ディスク増設
          b-form-text(v-if="regist_data.option.dn_drive" :class="neo_option_data_class") desknet'sドライブ ディスク増設（20GBあたり￥2,200/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left 20GB × {{regist_data.option.dn_drive.disk_size}} = {{regist_data.option.dn_drive.disk_size * 20}} GB増設
          b-form-text(style="height: 30px;" :class="neo_option_data_class")
        template(v-if="regist_data.security && Object.keys(regist_data.security).length > 0")
          h5(:class="neo_service_title_class") セキュリティオプション
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#security-option'}") 修正
          b-form-text(v-if="regist_data.security.basic" :class="neo_option_data_class") BASIC認証 (無償)
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left ユーザーID ： {{regist_data.security.basic.basic_id}}
                basic-password(form_name="パスワード", :password="regist_data.security.basic.basic_password")
                template(v-if="regist_data.security.basic.basic_except_ip")
                  b-form-text.text-left 認証を除外するIPアドレス：
                  b-form-text.text-left.ml-1(v-for="(ip_addr) of basic_except_ip") {{ip_addr}}
          b-form-text(v-if="regist_data.security.connect_permit_ip" :class="neo_option_data_class") 接続元IPアドレス制限
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left 接続を許可するIPアドレス：
                b-form-text.text-left.ml-1(v-for="(ip_addr) of connect_permit_ip") {{ip_addr}}
          //- b-form-text(v-if="regist_data.security.secure" :class="neo_option_data_class") セキュアブラウザ（1ユーザー￥110/月 または 1デバイス￥385/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left 端末認証：{{secure_browser_terminal}}
                b-form-text.text-left(v-if="regist_data.security.secure.secure_browser_terminal==='02'") デバイス数：{{regist_data.security.secure.secure_browser_device}} デバイス
                template(v-if="this.regist_data.security.secure.secure_except_ip")
                  b-form-text.text-left セキュアブラウザを適用しないIPアドレス：
                  b-form-text.text-left.ml-1(v-for="(ip_addr) of secure_except_ip") {{ip_addr}}
          b-form-text(v-if="regist_data.security.client" :class="neo_option_data_class") クライアント認証（1デバイス￥220/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left {{regist_data.security.client.device}} デバイス
                template(v-if="this.regist_data.security.client.cert_except_ip")
                  b-form-text.text-left 認証を除外するIPアドレス：
                  b-form-text.text-left.ml-1(v-for="(ip_addr) of cert_except_ip") {{ip_addr}}
          b-form-text(style="height: 30px;" :class="neo_option_data_class")
        template(v-if="regist_data.mail && Object.keys(regist_data.mail).length > 0")
          h5(:class="neo_service_title_class") メールサービス
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#mail-service'}") 修正
          b-form-text(v-if="regist_data.mail.arena" :class="neo_option_data_class") WebARENA（1アカウント￥220/月）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left 利用ドメイン名 ： {{regist_data.mail.arena.wa_domain}}
                b-form-text.text-left アカウント数 ： {{regist_data.mail.arena.account}} アカウント
          b-form-text(v-if="regist_data.mail.cyber" :class="neo_option_data_class") CYBERMAILΣ（1アカウント￥220～/月、初期￥55,000～）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left アカウント数 ： {{regist_data.mail.cyber.account}} アカウント
                b-form-text.text-left.mb-2 メールボックス容量 ： {{cyber_capacity}}
                template(v-if="regist_data.mail.cyber.options")
                  b-form-text.font-weight-bold.text-left.mb-1 オプション
                  b-form-text.text-left(v-if="regist_data.mail.cyber.options.indexOf('00') !== -1") ・情報漏えい対策(有償)を利用する
                  b-form-text.text-left(v-if="regist_data.mail.cyber.options.indexOf('01') !== -1") ・添付ファイル暗号化・分離(有償)を利用する
                  template(v-if="regist_data.mail.cyber.options.indexOf('02') !== -1")
                    b-form-text.text-left ・メールアーカイブ＆監査(有償)を利用する
                    b-form-text.text-left.ml-3 （ {{mail_keep}} )
                  b-form-text.text-left(v-if="regist_data.mail.cyber.options.indexOf('03') !== -1").mb-2 ・クラウド型サンドボックス(有償)を利用する
          b-form-text(style="height: 30px;" :class="neo_option_data_class")
        template(v-if="regist_data.mail_security && Object.keys(regist_data.mail_security).length > 0")
          h5(:class="neo_service_title_class") メールセキュリティサービス
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-mail-security-service', params: { service_type: 'neo', anchor: 'neo_mail_security_service'}}") 修正
          b-form-text(v-if="regist_data.mail_security.mailgates" :class="neo_option_data_class") MAILGATES Σ（1アカウント￥110～/月、初期￥55,000～）
            b-row
              b-col(cols="1")
              b-col
                b-form-text.text-left 利用ドメイン名 ： {{regist_data.mail_security.mailgates.mailgates_domain}}
                b-form-text.text-left.mb-2 アカウント数 ： {{regist_data.mail_security.mailgates.account}} アカウント
                template(v-if="regist_data.mail_security.mailgates.options")
                  b-form-text.font-weight-bold.text-left.mb-1 オプション
                  b-form-text.text-left(v-if="regist_data.mail_security.mailgates.options.indexOf('01') !== -1") ・アンチウイルス・スパム＋サンドボックスを利用する
                  b-form-text.text-left(v-if="regist_data.mail_security.mailgates.options.indexOf('02') !== -1") ・誤送信対策・審査を利用する
                  b-form-text.text-left(v-if="regist_data.mail_security.mailgates.options.indexOf('03') !== -1").mb-2 ・添付ファイル暗号化・分離を利用する
          b-form-text(style="height: 30px;" :class="neo_option_data_class")
        h5(:class="neo_service_title_class") ご希望サブドメイン名
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#sub-domain'}") 修正
        b-form-text(:class="neo_service_data_class") {{regist_data.sub_domain}}.dn-cloud.com
        b-form-text(style="height: 30px;")
        template(v-if="regist_data.migration_url")
          h5(:class="neo_service_title_class") 無料お試し版からのデータ移行
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#migration-url'}") 修正
          b-form-text(:class="neo_option_data_class") 希望する
          b-form-text(:class="neo_no_border") 試使用環境URL：{{regist_data.migration_url}}
          b-form-text.pb-2(:class="neo_no_border_top") 作業日時 ： {{migration_date}}
        template(v-else)
          h5(:class="neo_service_title_class") ご利用開始希望日
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#preferred-date'}") 修正
          b-form-text(:class="neo_service_data_class") {{preferred_date}}
        b-form-text(style="height: 30px;")
        template(v-if="regist_data.estimate")
          h5(:class="neo_service_title_class") お見積番号
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#estimate'}") 修正
          b-form-text.pb-2(v-html="estimate" :class="neo_service_data_class")
          b-form-text(style="height: 30px;")
        template(v-if="regist_data.remarks")
          h5(:class="neo_service_title_class") 備考
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractNeoOrder', hash: '#remarks'}") 修正
          b-form-text.white-space(:class="neo_service_data_class") {{regist_data.remarks}}
          b-form-text(style="height: 30px;")

        payment-detail-list(:register_data="payment_detail", :show_notice="{plan: true, neo: true, chat: false}", :contract_type="contract_type")
</template>

<script>
import PaymentDetailList from "@/components/PaymentDetailList"
import BasicPassword from '@/components/BasicPassword';

export default {
  name: "ContractNeoConfirmData",
  components: {
    PaymentDetailList,
    BasicPassword
  },
  props: {
    regist_data: { type: Object, required: true},
    contract_type: { type: Number, required: false, Default:0},  // ご契約種別(0:月払い、1:年間一括払い)
  },
  data() {
    return {
      plan_service_title_class: "ml-3 py-2 mr-0 mb-2 font-weight-bold border-top border-bottom title-bg-color-plan",
      plan_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary border-color-plan label-font-size",
      neo_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 title-bg-color",
      neo_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary label-font-size",
      neo_option_data_class: "ml-3 pt-2 px-2 mb-0 border-top border-primary label-font-size",
      neo_no_border: "ml-3 pt-2 px-2 mb-2 border-primary label-font-size",
      neo_no_border_top: "ml-3 pt-2 px-2 mb-2 border-bottom border-primary label-font-size",

      plans: {
        'light': { title: 'ライト', price: 660, services:['neo'], plan:'light'},
        'standard': { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan:'standard' },
        '': { title: '', price: '', services: [], plan: '' }
      },
    }
  },
  computed: {
    basic_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.security.basic.basic_except_ip, 5, '\n')
    },
    connect_permit_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.security.connect_permit_ip, 5, '\n')
    },
    secure_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.security.secure.secure_except_ip, 5, '\n')
    },
    cert_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.security.client.cert_except_ip, 5, '\n')
    },
    estimate() {
      // 見積番号を1つずつ改行して表示する
      return 'No : <br>' + this.regist_data.estimate.replaceAll(/\r?\n/g, '<br>')
    },
    preferred_date() {
      // 2021年12月2日(木) のような形式にする
      return this.showDateString(this.regist_data.preferred_date)
    },
    migration_date() {
      // 2021年12月2日(木) 11:00 - 12:00 のような形式にする
      return this.showDateString(this.regist_data.migration_date, this.regist_data.migration_time_from, this.regist_data.migration_time_to)
    },
    // セキュアブラウザ.端末認証のフラグ値変換
    secure_browser_terminal() {
      let text = ''
      if (this.regist_data.security.secure.secure_browser_terminal === '01') {
        text = 'なし'
      }
      else if (this.regist_data.security.secure.secure_browser_terminal === '02') {
        text = 'あり'
      }

      return text
    },
    // メールボックス容量
    cyber_capacity() {
      switch (this.regist_data.mail.cyber.mailbox) {
        case '01':
          return '5GB'
        case '02':
          return '10GB'
        case '03':
          return '50GB'
        case '04':
          return '100GB'
        default:
          return '（容量を選択してください）'
      }
    },
    // メールアーカイブ保存期間
    mail_keep() {
      switch (this.regist_data.mail.cyber.keep) {
        case '01':
          return '5年保存'
        case '02':
          return '7年保存'
        default:
          return '（保存期間を選択してください）'
      }
    },
    // ご注文明細に渡す変数
    payment_detail() {
      // 変数の初期化
      let params = {'neo': {}}

      Object.keys(this.regist_data).forEach((key) => {
        // プランの場合
        if (key === 'plan') {
          // そのまま渡す
          params[key] = this.regist_data[key]
        }
        // お見積番号の場合
        else if (key === 'estimate') {
          // そのまま渡す
          params[key] = this.regist_data[key]
        }
        // 上記以外の場合
        else {
          // neoの中に入れて渡す
          params.neo[key] = this.regist_data[key]
        }
      })

      // 作成した変数を返す
      return params
    }
  },
}
</script>

<style scoped>
.message-border-style {
  border-width: 2px !important;
}
.title-bg-color {
  background-color: #f2ffff;
}
.label-font-size {
  font-size: 16px;
}
.anchor-button {
  height: 22px;
  vertical-align: center;
  text-align: center;
  margin-top: -2px;
  padding-top: 0;
}
.white-space {
  white-space: pre-wrap;
}
.title-bg-color-plan {
  background-color: #fceaee;
}
.border-color-plan {
  border-color: #eb6ea0!important;
}
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}
</style>
